import { useState } from 'react';
import { API_URL } from '@constants';
import { useApiConfig } from '@hooks/useApiConfig';

const ENDPOINT_URL = '/users/update-preferred-language';

/**
 * Updates the authenticated user's preferred language.
 */
export const useUpdatePreferredLanguage = () => {
    const { getHeaders, handleCommonErrors } = useApiConfig();
    const [loading, setLoading] = useState<boolean>(false);

    const request = async (language: string) => {
        setLoading(true);

        try {
            await fetch(`${API_URL}${ENDPOINT_URL}?language=${language}`, {
                method: 'PUT',
                headers: getHeaders(),
            });
        } catch (error: any) {
            handleCommonErrors(error);
        } finally {
            setLoading(false);
        }
    };

    return { request, loading };
};
